import { render, staticRenderFns } from "./postPinterest.vue?vue&type=template&id=b6eddfa8&"
import script from "./postPinterest.vue?vue&type=script&lang=js&"
export * from "./postPinterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports